jQuery(document).ready(function ($) {
    $('.beforeAfter__rightInner').each(function() {
        var $container = $(this);
        var $controller = $container.find('.beforeAfter__revealControl');
        var $afterImageFrame = $container.find('.beforeAfter__afterImageFrame');
        var $beforeImage = $container.find('.beforeAfter__beforeImage');
        var $afterImage = $container.find('.beforeAfter__afterImage');
        var isDragging = false;
        
        // Get initial position (default to 50%)
        var currentPosition = 50;
        
        // Function to sync after image width with before image width
        function syncImageWidths() {
            var beforeImageWidth = $beforeImage.width();
            if (beforeImageWidth > 0) {
                $afterImage.css('width', beforeImageWidth + 'px');
            }
        }
        
        // Function to update positions based on percentage
        function updatePosition(percentage) {
            // Clamp percentage between 0 and 100
            percentage = Math.max(0, Math.min(100, percentage));
            currentPosition = percentage;
            
            // Update controller left position
            $controller.css('left', percentage + '%');
            
            // Update after image frame width (inverse percentage)
            $afterImageFrame.css('width', (100 - percentage) + '%');
        }
        
        // Function to get percentage from mouse/touch position
        function getPercentageFromEvent(e) {
            var containerRect = $container[0].getBoundingClientRect();
            var clientX = (e.type === 'touchmove' || e.type === 'touchstart') ? e.originalEvent.touches[0].clientX : e.clientX;
            var x = clientX - containerRect.left;
            var percentage = (x / containerRect.width) * 100;
            return percentage;
        }
        
        // Mouse down handler
        $controller.on('mousedown', function(e) {
            e.preventDefault();
            isDragging = true;
            $('.beforeAfter__tooltip').fadeOut();
            updatePosition(getPercentageFromEvent(e));
        });
        
        // Touch start handler
        $controller.on('touchstart', function(e) {
            e.preventDefault();
            isDragging = true;
            updatePosition(getPercentageFromEvent(e));
        });
        
        // Mouse move handler (on document to track even if mouse leaves container)
        $(document).on('mousemove', function(e) {
            if (isDragging) {
                e.preventDefault();
                updatePosition(getPercentageFromEvent(e));
            }
        });
        
        // Touch move handler
        $(document).on('touchmove', function(e) {
            if (isDragging) {
                e.preventDefault();
                var containerRect = $container[0].getBoundingClientRect();
                var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
                var clientX = touch.clientX;
                var x = clientX - containerRect.left;
                var percentage = (x / containerRect.width) * 100;
                updatePosition(percentage);
            }
        });
        
        // Mouse up handler
        $(document).on('mouseup', function() {
            isDragging = false;
        });
        
        // Touch end handler
        $(document).on('touchend touchcancel', function() {
            isDragging = false;
        });
        
        // Sync image widths on ready
        syncImageWidths();
        
        // Sync image widths after images are loaded
        $beforeImage.on('load', function() {
            syncImageWidths();
        });
        $afterImage.on('load', function() {
            syncImageWidths();
        });
        
        // Sync image widths on window resize
        $(window).on('resize', function() {
            syncImageWidths();
        });
        
        // Initialize position
        updatePosition(currentPosition);
    });

    function preloadImage(url) {
        if (url) {
            var img = new Image();
            img.src = url;

            img.onload = function() {
                console.log('Image loaded: ' + url);
            };
            img.onerror = function() {
                console.log('Image failed to load: ' + url);
            };
        }
    }

    $('.beforeAfter__button').each(function() {
        beforeImageUrl = $(this).attr('data-before-image');
        afterImageUrl = $(this).attr('data-after-image');
        
        preloadImage(beforeImageUrl);
        preloadImage(afterImageUrl);
    });
    
    // Button click handler
    $('.beforeAfter__button').on('click', function() {
        $('.beforeAfter__button').removeClass('beforeAfter__button--active');
        $(this).addClass('beforeAfter__button--active');
        var beforeImage = $(this).attr('data-before-image');
        var afterImage = $(this).attr('data-after-image');
        var link = $(this).attr('data-link');
        var linkText = $(this).attr('data-link-text');

        $('.beforeAfter__beforeImage').attr('src', beforeImage);
        $('.beforeAfter__afterImage').attr('src', afterImage);
        $('.beforeAfter__link').attr('href', link);
        $('.beforeAfter__link span').text(linkText);
    });

    $('.beforeAfter__mobileSelect').on('change', function() {
        var selectedOption = $(this).find('option:selected');
        var beforeImage = selectedOption.attr('data-before-image');
        var afterImage = selectedOption.attr('data-after-image');
        var link = selectedOption.attr('data-link');
        var linkText = selectedOption.attr('data-link-text');

        $('.beforeAfter__beforeImage').attr('src', beforeImage);
        $('.beforeAfter__afterImage').attr('src', afterImage);
        $('.beforeAfter__link').attr('href', link);
        $('.beforeAfter__link span').text(linkText);
    });
});